import * as THREE from "three";
import { DbLayer } from "../core/DbLayer";
import { ModelManager } from "../manager/ModelManager";
import { DBEntity, DbLine, DbMesh } from "@/CadEngine";

/**
 * p2d文件格式加载，主要代码位于woerker内
 */
export class P2dLoader {
  //@ts-ignore
  m_model: ModelManager;

  constructor() {}

  load(
    url: string,
    canEdit: boolean,
    model: ModelManager,
    onComplete: (isComplete: boolean, loadDatas: DBEntity[]) => void,
    isSourceData: boolean | undefined = undefined
  ) {
    this.m_model = model;
    this.loadProc(url, canEdit, onComplete, isSourceData);
  }
  loadProc(
    url: string,
    canEdit: boolean,
    onComplete: (isComplete: boolean, loadDatas: DBEntity[]) => void,
    isSourceData: boolean | undefined = undefined
  ) {
    const worker = new Worker(
      new URL("@/worker/P2dLoader.worker.ts", import.meta.url)
    );
    worker.postMessage({ command: "load", url: url });
    worker.onmessage = ({
      data: { lines, meshs, layers, blocks, instances, complete },
    }) => {
      let loadDatas: DBEntity[][] = [];
      if (lines) {
        let addLines = this.m_model.addlines(lines, canEdit, isSourceData);
        loadDatas.push(addLines);
      }
      if (meshs) {
        let addMeshs = this.m_model.addMeshs(meshs, canEdit, isSourceData);
        loadDatas.push(addMeshs);
      }
      if (layers) this.m_model.addLayers(layers);
      if (blocks) this.m_model.addBlocks(blocks);
      if (instances) this.m_model.addInstances(instances);
      if (complete) {
        this.m_model.OnComplete();
        onComplete(complete, loadDatas.flat());
        worker.terminate();
      } else if (!complete) {
        this.m_model.OnComplete();
        onComplete(complete, loadDatas.flat());
        // worker.terminate();
      }
    };
  }
}
